import React, {FC, SVGAttributes} from "react"

const ChevronDownIcon: FC<SVGAttributes<SVGElement>> = ({...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#344563"
                fillRule="evenodd"
                d="M12.528 16.285a.749.749 0 01-1.06 0l-5.628-5.63a.75.75 0 111.061-1.06l5.097 5.098 5.096-5.098a.75.75 0 111.06 1.06l-5.626 5.63z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export default ChevronDownIcon
